import { motion } from "framer-motion";
import { MessageCircleHeart } from "lucide-react";
import { SectionHead, Reveal } from "./effects";

const proofs = [
  {
    img: "/proof/proof-3.jpg",
    quote: "Thank you for the collab. The footage looked amazing!",
    name: "Haraz",
    tag: "Brand Client",
    rotate: "-rotate-2",
  },
  {
    img: "/proof/proof-1.jpg",
    quote: "The video is really nice, thank you so much.",
    name: "YouTube Creator",
    tag: "Long-Form Client",
    rotate: "rotate-1",
  },
  {
    img: "/proof/proof-2.jpg",
    quote: "Great video!! Thanks so much!",
    name: "Returning Client",
    tag: "Short-Form Client",
    rotate: "rotate-2",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-[#070709] overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute top-0 left-1/4 h-[300px] w-[500px] rounded-full bg-[#D4AF37]/6 blur-[140px]" />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead
        testId="testimonials"
        eyebrow="Client Love"
        align="center"
        title={
          <>
            Proof, <span className="text-gradient-blue">straight from the DMs</span>
          </>
        }
        sub="No inflated claims — just real messages from real clients after delivery."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 max-w-5xl mx-auto">
        {proofs.map((p, i) => (
          <Reveal key={p.img} delay={i * 0.12}>
            <motion.figure
              data-testid={`testimonial-card-${i + 1}`}
              whileHover={{ y: -10, rotate: 0, scale: 1.03 }}
              transition={{ type: "spring", stiffness: 200, damping: 16 }}
              className={`group relative rounded-3xl border border-[#D4AF37]/20 bg-[#0a0a0c] p-4 hover:border-[#D4AF37]/60 hover:shadow-[0_20px_60px_rgba(212,175,55,0.2)] transition-all duration-500 ${p.rotate}`}
            >
              <div className="rounded-2xl overflow-hidden border border-white/5">
                <img
                  src={p.img}
                  alt={`Client feedback from ${p.name}`}
                  loading="lazy"
                  className="w-full h-auto object-cover group-hover:scale-[1.02] transition-transform duration-700"
                />
              </div>
              <figcaption className="pt-5 pb-2 px-1">
                <MessageCircleHeart size={18} className="text-[#F5DE81] mb-3" />
                <p className="text-sm text-slate-200 leading-relaxed mb-4">“{p.quote}”</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-white">{p.name}</span>
                  <span className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]/80">{p.tag}</span>
                </div>
              </figcaption>
            </motion.figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
